/* eslint-disable no-mixed-operators */

import {WixSdk} from 'js-sdk-wrapper';
import {getExperiments} from 'music-shared/dist/src/experiments/experiment-manager';
import * as PL from 'wix-music-widget';
import {BI_ERRORS} from '../logging/errors';
import {addNewRelicAttributes, logError, logMetricToNewRelic} from '../logging/logging';
import {sendPlayerStartedEvent} from '../statistics/bi';
import {debounce} from '../utils/functions';
import {getSharedTrackId} from '../utils/url';
import {scrollToPlayer} from '../utils/wix-sdk';
import {initPlayer as initPlayerRaw} from './init-player';
import {subscribeToExternalEvents} from './subscribe-to-external-events';

export function init() {
  WixSdk.Performance.applicationLoadingStep(1, 'page-loaded');

  try {
    PL.errorReporter.on('error', logError);
    PL.appStatus.on('metric', logMetricToNewRelic);
    addNewRelicAttributes();
  } catch (reason) {
    logError(BI_ERRORS.widget.init.statisticSubscribe, {reason});
  }

  const EXPERIMENTS_DISABLED = false;
  let isAppOnPage = true;
  let preventUpdates = false;

  let promise = Promise.resolve();

  const getViewMode = WixSdk.Utils.getViewMode;

  const experimentsPromise = EXPERIMENTS_DISABLED ? Promise.resolve() :
    getExperiments('wix-music', 500)
      .catch(err => {
        console.warn(err); // eslint-disable-line no-console
        logMetricToNewRelic('experiment-load-timeout');
        return {};
      });

  function initPlayer(newSettings?, {forceUpdate = false} = {}) {
    if (preventUpdates) {
      return promise;
    }
    promise = promise
      .catch(reason => { // if last init was not successful, try to repeat
        console.error(reason);
      })
      .then(() => {
        return initPlayerRaw(newSettings, {forceUpdate, experimentsPromise, isAppOnPage});
      });

    return promise;
  }

  if (getViewMode() === 'editor' || getViewMode() === 'preview') {
    window.addEventListener('resize', debounce(() => {
      initPlayer();
    }, 1000));
  }

  Promise.all([
      WixSdk.Styles.getStyleParams(),
      WixSdk.getSiteInfo()
        .catch(reason => {
          logError(BI_ERRORS.tpa.wix.siteInfo.get, {reason});
          return null;
        })
    ])
    .then(([styleParams, siteInfo]) => {
      styleParams = {...styleParams};

      WixSdk.Performance.applicationLoadingStep(2, 'style-params-loaded');

      const sharedTrackId = getSharedTrackId(siteInfo);
      if (sharedTrackId) {
        styleParams.sharedTrackId = sharedTrackId;
        scrollToPlayer();
      }

      return initPlayer(styleParams)
        .then(player => {
          subscribeToExternalEvents({
            player,
            initPlayer,
            isAppOnPageChanged: _isAppOnPage => {
              isAppOnPage = _isAppOnPage;
            },
            preventUpdatesChanged: _preventUpdates => {
              preventUpdates = _preventUpdates;
            }
          });
          WixSdk.Performance.applicationLoaded();
        });
    })
    .catch(reason => {
      if (reason && reason.message === 'Browser Not Supported') {
        sendPlayerStartedEvent();
        WixSdk.Performance.applicationLoaded();
        return;
      }
      logError(BI_ERRORS.widget.init.initial, {reason});
    });
}




// WEBPACK FOOTER //
// ./widget-player/widget-player.ts